/* index.tsx generated by @compiled/babel-plugin v2.0.0 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2pQraJ0Qmj%7Bscroll-margin-inline%3A750pt%7D");
import { type Ref, type RefAttributes, useMemo, useRef } from 'react';
import type { RouterLinkComponentProps } from '@atlaskit/app-provider';
import { LinkMenuItem as AtlasLinkMenuItem } from '@atlaskit/side-nav-items/link-menu-item';
import { forwardRefWithGeneric } from '../../utils/forward-ref-with-generic';
import mergeRefs from '../../utils/merge-refs';
import { ListItem } from '../list-item';
import { MenuItemBase } from '../menu-item';
import type { MenuItemCommonProps, MenuItemLinkOrButtonCommonProps, MenuItemOnClick, MenuItemSlots } from '../menu-item/types';
const listItemStyles = {
  root: "_2pQraJ0Qmj"
};
export type LinkMenuItemProps<RouterLinkConfig extends Record<string, unknown> = never> = MenuItemLinkOrButtonCommonProps & RouterLinkComponentProps<RouterLinkConfig> & {
  /**
   * The native `target` attribute for the anchor element.
   */
  target?: HTMLAnchorElement['target'];
  /**
   * Whether the menu item is selected.
   */
  isSelected?: boolean;

  /**
   * Called when the user has clicked on the trigger content.
   */
  onClick?: MenuItemOnClick<HTMLAnchorElement>;
  /**
   * Whether the ADS navigation (left-nav) is enabled rather than the in-component navigation
   */
  isADSNavigationEnabled: boolean;
  /**
   * Size variant for the menu item.
   * - 'default': 2rem (32px) height
   * - 'small': 3.4rem (54px) height with custom padding
   * - 'large': 3.75rem (60px) minimum height with custom padding
   */
  size?: 'default' | 'small' | 'large';
  /**
   * Whether the new all conversation screen is enabled
   */
  isNewAllConversationScreenEnabled?: boolean;
  /**
   * When true, disables the inner :active background on the anchor/button.
   * Useful when the container already provides its own pressed/selected highlight.
   */
  noActiveBackground?: boolean;
};
const LinkMenuItemNoRef = <RouterLinkConfig extends Record<string, unknown> = never,>({
  testId,
  actions,
  children,
  description,
  elemAfter,
  elemBefore,
  href,
  target,
  actionsOnHover,
  isSelected,
  onClick,
  interactionName,
  isContentTooltipDisabled,
  visualContentRef,
  listItemRef,
  level = 0,
  isADSNavigationEnabled,
  size,
  isNewAllConversationScreenEnabled,
  noActiveBackground
}: LinkMenuItemProps<RouterLinkConfig>, forwardedRef?: Ref<HTMLAnchorElement>) => {
  const itemRef = useRef<HTMLDivElement>(null);
  const ref = useMemo(() => {
    return mergeRefs([itemRef, listItemRef ?? null]);
  }, [itemRef, listItemRef]);
  const commonProps = {
    testId,
    description,
    actions,
    elemAfter,
    href,
    target,
    actionsOnHover,
    isSelected,
    onClick,
    ref: forwardedRef,
    visualContentRef,
    interactionName,
    isContentTooltipDisabled
  };
  return isNewAllConversationScreenEnabled ? <ListItem ref={ref} xcss={listItemStyles.root}>
			<MenuItemBase {...commonProps} level={level} size={size} elemBefore={elemBefore} noActiveBackground={noActiveBackground}>
				{children}
			</MenuItemBase>
		</ListItem> : isADSNavigationEnabled ?
  //We must pass the elemBefore prop separately and cast it because the forked type definition and
  // ADS type definition COLLAPSE_ELEM_BEFORE_TYPE are each created using unique symbols
  <AtlasLinkMenuItem {...commonProps} description={typeof description === 'string' ? description : undefined} elemBefore={(elemBefore as React.ReactNode)}>
			{children}
		</AtlasLinkMenuItem> : <ListItem ref={ref} xcss={listItemStyles.root}>
			<MenuItemBase {...commonProps} level={level}
    // TODO Always use "open in new window" icon when `openInNewWindow` prop is true
    elemBefore={elemBefore}>
				{children}
			</MenuItemBase>
		</ListItem>;
};

/**
 * LinkMenuItem
 *
 * A menu item link. It should be used within a `ul`.
 */
export const LinkMenuItem: <RouterLinkConfig extends Record<string, unknown> = never>(props: MenuItemCommonProps & MenuItemSlots & {
  description?: React.ReactNode;
  listItemRef?: React.Ref<HTMLDivElement>;
} & RouterLinkComponentProps<RouterLinkConfig> & {
  /**
   * The native `target` attribute for the anchor element.
   */
  target?: HTMLAnchorElement['target'];
  /**
   * Whether the menu item is selected.
   */
  isSelected?: boolean;
  /**
   * Called when the user has clicked on the trigger content.
   */
  onClick?: MenuItemOnClick<HTMLAnchorElement>;
  /**
   * Whether the ADS navigation (left-nav) is enabled rather than the in-component navigation
   */
  isADSNavigationEnabled: boolean;
  /**
   * Size variant for the menu item.
   * - 'default': 2rem (32px) height
   * - 'large': 3.75rem (60px) minimum height with custom padding
   */
  size?: 'default' | 'small' | 'large';
  /**
   * Whether the new all conversation screen is enabled
   */
  isNewAllConversationScreenEnabled?: boolean;
  /**
   * When true, disables the inner :active background on the anchor/button.
   * Useful when the container already provides its own pressed/selected highlight.
   */
  noActiveBackground?: boolean;
} & RefAttributes<HTMLAnchorElement>) => React.ReactElement | null = forwardRefWithGeneric(LinkMenuItemNoRef);